import { render } from "./products.vue?vue&type=template&id=ff93eabe&ts=true"
import script from "./products.vue?vue&type=script&lang=ts"
export * from "./products.vue?vue&type=script&lang=ts"

import "./products.vue?vue&type=style&index=0&id=ff93eabe&lang=css"

import exportComponent from "/var/www/prod/LVCManagerWebsitePerso/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__